/**
 * Log client-side errors to the server
 */

'use strict';

var $ = require('jquery');
var AppConstants = require('../constants').AppConstants;

var MAX_ERRORS = 2;
var errorsCount = 0;

function logToCAL(data) {
    $.post(AppConstants.LOG_ERROR_URL, {
        message: data.error && data.error.message || data.message,
        href: window.location.href,
        file: data.file,
        line: data.line,
        column: data.column,
        stack: data.error ? data.error.stack : '',
        userAgent: navigator.userAgent
    });
}

function handleUncaughtError(message, file, line, column, error) {
    errorsCount++;
    if (errorsCount > MAX_ERRORS) {
        return;
    }

    logToCAL({
        message: message,
        file: file,
        line: line,
        column: column,
        error: error
    });
}

function handlePromiseRejection(e) {
    e.preventDefault();
    if (e.reason && e.reason.stack) {
        handleUncaughtError(e.reason.message, '', 0, 0, e.reason);
    }
}

function startTracking() {
    window.onerror = handleUncaughtError;
    window.addEventListener('unhandledrejection', handlePromiseRejection);
}

module.exports = {
    startTracking: startTracking
};



/** WEBPACK FOOTER **
 ** ./public/js/utils/ErrorLogger.js
 **/